
export const GTM_EVENT = Object.freeze({
  'appStarted': 'app-started',
  'pageNavigated' : 'page-navigated',
  'idScanStarted' : 'id-scan-started',
  'idScanFinished' : 'id-scan-finished',
  'productSelected' : 'select_item',
  'productAddToCart' : 'add_to_cart',
  'productRemoveFromCart' : 'remove_from_cart'
});

export const GTM_VARIABLE = Object.freeze({
  'mygaAgentReferralCode': 'mygaAgentReferralCode',
  'mygaPage': 'mygaPage',
  'mygaPageMax': 'mygaPageMax',
  'mygaPrincipalToken': 'mygaPrincipalToken',
  'mygaScheduleToken': 'mygaScheduleToken',
  'mygaUsername': 'mygaUsername',
  'mygaSessionId': 'mygaSessionId',
  'mygaSubmissionPath': 'mygaSubmissionPath',
  'mygaIdScanStatus': 'mygaIdScanStatus'
});

export const gtmSetValue = (key, value) => {
  window.dataLayer = window.dataLayer || [];
  let config = {};
  config[key] = value;
  window.dataLayer.push(config)
};

export const gtmGetValue = (key) => {
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer[key];
}

export const gtmLogEvent = (name, params = {}) => {
  window.dataLayer = window.dataLayer || [];
  let config = Object.getOwnPropertyNames(params).reduce((obj,key)=>{
    obj[key] = params[key];
    return obj;
  },{'event': name});
  window.dataLayer.push(config);
};

/**
 * Trigger a GA4 Ecommerce event
 * @param name name of the ecommerce event
 * @param items product description objects associated with the ecommerce event
 */
export const gtmLogEcommerceEvent = (name, ecommerce = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'ecommerce': null });  // Clear the previous ecommerce object.
  window.dataLayer.push({
    'event': name,
    'ecommerce': ecommerce
  });
};
